import React, { useState } from "react";
import { Field, Form, FormikProvider, useFormik } from "formik";
import { Link, useHistory } from "react-router-dom";
import * as Yup from 'yup';
import styles from "../css/style.module.css"
import Select from 'react-select'
import PhoneInputFieldFull from "../customInputs/PhoneInputFieldFull";
import { Backdrop,CircularProgress,makeStyles } from "@material-ui/core";
import { NODE_API_URL } from "../../../../../env_config";
import axios from "axios";
import { Alert } from 'react-bootstrap';

const customStyles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 9999 // You can set this to a value that ensures the menu appears on top of other elements
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999
    })
};

const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }));

// Custom FormikSelect component
const FormikSelect = ({ field, form, options, ...props }) => {
    return (
        <Select
            {...props}
            options={options}
            name={field.name}
            value={options ? options.find(option => option.value === field.value) : ''}
            onChange={(option) => form.setFieldValue(field.name, option.value)}
            onBlur={field.onBlur}
        />
    );
};
const Register = () =>{
    const history = useHistory()
    const classes = useStyles();
    const [openLoader,setOpenLoader] = useState(false)
    const [success,setSuccess] = useState("")
    const [error, setError] = useState("");
    const enableLoading = () => {
        // setLoading(true);
        setOpenLoader(true);
    };
    const disableLoading = () => {
        setOpenLoader(false);
    };
    const initialValues = {
        firstname:'',
        lastname:'',
        email:'',
        password:'',
        confirmpassword:'',
        companyname:'',
        contact:'',
        city:'',
        country:'',
        source:'web'
    }
    const validate = Yup.object({
        firstname: Yup.string()
            .required('First name is Required'),
        lastname: Yup.string()
            .required('Last Name is Required'),
        email: Yup.string()
            .email("Email is invalid")
            .required('Email is Required'),
        password: Yup.string()
            .min(8, "Password must be at least 8 charectors" )
            .required('Password is Required'),
        confirmpassword: Yup.string()
            .oneOf([Yup.ref('password'), null],'Password must match')
            .required('Confirm Password is Required'),
        companyname: Yup.string()
            .required('Company Name is Required'),
        contact: Yup.string()
            .required('Contact Number is Required'),
        city: Yup.string()
            .required('City Name is Required'),
        country: Yup.string()
            .required('Country Name is Required')
    })  
    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema: validate,
        onSubmit: (values, { setSubmitting }) => {
            enableLoading()
            axios({
                method: "POST",
                url: `${NODE_API_URL}/customer/CustomerRegistration`,
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("token")}`
                },
                data:{
                    ...values
                }
            }).then((res) => {
                // console.log(res.data,"resres")
                if(res && res.data){
                    disableLoading()
                    setSubmitting(false)
                    if(!res.data.success){
                        setError(res.data.message)
                    }
                    else{
                        if(res.data.message === "Customer Registered Successfully!"){
                            history.push("/register-success")
                        }
                    }
                }
            }).catch(error => {
                disableLoading()
                setSubmitting(false)
                console.log(error.response.data.message,"errorerror")
                if(error?.response?.data?.message){
                    setError(error?.response?.data?.message)
                }
            })
        }
    });
    let array = ['Afghanistan', "Aland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Barbuda", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Trty.", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Caicos Islands", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, Democratic Republic of the", "Cook Islands", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Futuna Islands", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard", "Herzegovina", "Holy See", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Jan Mayen Islands", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea", "Korea (Democratic)", "Kuwait", "Kyrgyzstan", "Lao", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "McDonald Islands", "Mexico", "Micronesia", "Miquelon", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "Nevis", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestinian Territory, Occupied", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Principe", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Barthelemy", "Saint Helena", "Saint Kitts", "Saint Lucia", "Saint Martin (French part)", "Saint Pierre", "Saint Vincent", "Samoa", "San Marino", "Sao Tome", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "South Carolina","Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia", "South Sandwich Islands", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "The Grenadines", "Timor-Leste", "Tobago", "Togo", "Tokelau", "Tonga", "Trinidad", "Tunisia", "Turkey", "Turkmenistan", "Turks Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "US Minor Outlying Islands", "Uzbekistan", "Vanuatu", "Vatican City State", "Venezuela", "Vietnam", "Virgin Islands (British)", "Virgin Islands (US)", "Wallis", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"];

    let countries = array.map(value => {
        return {
            value:value,
            label:value
        }
    })
    const CountryValue = countries.find(
        option => option.value === formik.values.country
    );   
    return (
        <>
            <title>Register - Diamonds on Call Limited</title>
            <Backdrop className={classes.backdrop} open={openLoader} >
                <div className="px-5 py-3 bg-white rounded shadow-sm d-flex justify-content-center align-items-center"><CircularProgress size="30px" color="secondary" /> <span className="pl-2 font-weight-bold text-dark">Processing..</span></div>
            </Backdrop>
            <FormikProvider value={formik}>
                    <div className={styles.web_login}>
                        <div className="container">
                        <div>
              {error && <Alert variant="danger">
                {error}
              </Alert>}
              {success && <Alert variant="success">
                  {success}
              </Alert>}
            </div>
                            <h1 className={`text-left ${styles.titleH3}`}>Create an Account</h1>
                            <span className="text-muted font-weight-bold">Please enter the following information, it's free.</span>
                            <div className="row justify-content-center align-self-center my-4">
                                <Form>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <h3 className={styles.customH3title}>Personal Information</h3>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="sum_tab mb-4">
                                                            <Field
                                                                className={`form-control form-control-solid h-auto py-5 px-6 ${(formik.touched.firstname && formik.errors.firstname) ? ' is-invalid' : ''}`}
                                                                type="text"
                                                                name="firstname"
                                                                placeholder="Enter first name"
                                                                autoComplete="off"
                                                            />
                                                            {formik.touched.firstname && formik.errors.firstname ? (
                                                                <div className="invalid-feedback">{formik.errors.firstname}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="sum_tab mb-4">
                                                            <Field
                                                                className={`form-control form-control-solid h-auto py-5 px-6 ${(formik.touched.lastname && formik.errors.lastname) ? ' is-invalid' : ''}`}
                                                                type="text"
                                                                name="lastname"
                                                                placeholder="Enter last name"
                                                                autoComplete="off"
                                                            />
                                                            {formik.touched.lastname && formik.errors.lastname ? (
                                                                <div className="invalid-feedback">{formik.errors.lastname}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-12" >
                                                        <div className="sum_tab mb-4">
                                                            <Field
                                                                className={`form-control form-control-solid h-auto py-5 px-6 ${(formik.touched.email && formik.errors.email) ? ' is-invalid' : ''}`}
                                                                type="text"
                                                                name="email"
                                                                placeholder="Enter Email address"
                                                                autoComplete="off"
                                                            />
                                                            {formik.touched.email && formik.errors.email ? (
                                                                <div className="invalid-feedback">{formik.errors.email}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="sum_tab mb-4">
                                                            <Field
                                                                className={`form-control form-control-solid h-auto py-5 px-6 ${(formik.touched.password && formik.errors.password) ? ' is-invalid' : ''}`}
                                                                type="password"
                                                                name="password"
                                                                placeholder="Enter password"
                                                                autoComplete="off"
                                                            />
                                                            {formik.touched.password && formik.errors.password ? (
                                                                <div className="invalid-feedback">{formik.errors.password}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="sum_tab mb-4">
                                                            <Field
                                                                className={`form-control form-control-solid h-auto py-5 px-6 ${(formik.touched.confirmpassword && formik.errors.confirmpassword) ? ' is-invalid' : ''}`}
                                                                type="password"
                                                                name="confirmpassword"
                                                                placeholder="Confirm your password"
                                                                autoComplete="off"
                                                            />
                                                            {formik.touched.confirmpassword && formik.errors.confirmpassword ? (
                                                                <div className="invalid-feedback">{formik.errors.confirmpassword}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <h3 className={styles.customH3title}>Company Information</h3>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="sum_tab mb-4">
                                                            <Field
                                                                className={`form-control form-control-solid h-auto py-5 px-6 ${(formik.touched.companyname && formik.errors.companyname) ? ' is-invalid' : ''}`}
                                                                type="text"
                                                                name="companyname"
                                                                placeholder="Enter company name"
                                                                autoComplete="off"
                                                            />
                                                            {formik.touched.companyname && formik.errors.companyname ? (
                                                                <div className="invalid-feedback">{formik.errors.companyname}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="sum_tab mb-4">

                                                            <PhoneInputFieldFull
                                                                label="Mobile No"
                                                                name="contact"
                                                                country="in" // Set the default country code (e.g., India)
                                                                placeholder="Enter Mobile number"
                                                                required
                                                            />
                                                            {formik.touched.contact && formik.errors.contact ? (
                                                                <div className="invalid-feedback">{formik.errors.contact}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="sum_tab mb-4">
                                                            <Field
                                                                className={`form-control form-control-solid h-auto py-5 px-6 ${(formik.touched.city && formik.errors.city) ? ' is-invalid' : ''}`}
                                                                type="text"
                                                                name="city"
                                                                placeholder="Enter city name"
                                                                autoComplete="off"
                                                            />
                                                            {formik.touched.city && formik.errors.city ? (
                                                                <div className="invalid-feedback">{formik.errors.city}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="sum_tab mb-4">
                                                        <Field
                                                        name="country"
                                                        component={FormikSelect}
                                                        options={countries}
                                                        defaultValue={CountryValue}
                                                        styles={customStyles}
                                                        placeholder="Select Country"
                                                    />
                                                            {formik.touched.country && formik.errors.country ? (
                                                                <div className="invalid-feedback">{formik.errors.country}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="">
                                                    <div className="g-recaptcha" id="recaptcha" data-sitekey="6LcA4M4UAAAAAPEThMezf4BBDQh3YedGu4ut71oA"></div>
                                                    <span className="msg-error error text-danger"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 col-md-12 col-xs-12">
                                                <div className="sum_tab mb-4 text-center">
                                                    <button type="submit" className={`submit btn ${styles.btnPrimary} px-5 py-2 shadow-sm my-4` }disabled={formik.isSubmitting || !formik.isValid}>{formik.isSubmitting ? "Please wait..." : "Submit"}</button>
                                                    <button className={`btn ${styles.btnSecondary} px-5 py-2 my-4 mx-2 shadow-sm border`} onClick={()=> formik.resetForm()}>Reset</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                                <div className="col-12">
                                    <div className="sum_tab mb-4 text-center">
                                        <p className="m-0">By Pressing 'Join Us' you agreed to our <Link to="/terms" className={styles.A2}> Terms and Conditions</Link>.</p>
                                        <p>We'll occasionally send you account-related emails.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </FormikProvider>
        </>
    )
}
export default Register;